import { classnames } from 'Utils/classnames/classnames.utils';

import { COLORS, COMPLEMENTARY_COLORS } from 'Components/utils/color/colors';

export const themes = ({
  colorActive = COLORS.LIGHT_SAND,
  colorUnactive = COLORS.SAND,
  isActive = false,
} = {}) => ({
  default: {
    thRoot: classnames(
      'text-sans block items-stretch whitespace-nowrap rounded-pill border px-20 py-10 text-12 font-bold text-black transition-colors duration-250 ease-in',
      {
        [`bg-${colorActive} border-${colorActive}`]: isActive,
        [`bg-transparent border-${colorUnactive} hocus:bg-${colorActive} hocus:border-${colorActive}`]:
          !isActive,
      },
    ),
  },
  reverse: {
    thRoot: classnames(
      'text-sans block items-stretch whitespace-nowrap rounded-pill border px-20 py-10 text-12 font-bold transition-colors duration-250 ease-in',
      {
        [`bg-${colorActive} border-${colorActive} text-${COMPLEMENTARY_COLORS[colorActive]}`]:
          isActive,
        [`bg-${colorUnactive} border-${colorUnactive} text-${COMPLEMENTARY_COLORS[colorUnactive]} hocus:bg-${colorActive} hocus:border-${colorActive} hocus:text-${COMPLEMENTARY_COLORS[colorActive]}`]:
          !isActive,
      },
    ),
  },
});
